import "./RequestAQuote.module.css";
import Header from "@/reusable_sections/Header";
import LeadIntakeFormSection from "./sections/LeadIntakeFormSection";
import CommentCaFonctionne from "./sections/CommentCaFonctionne";
import MarketplaceFooter from "@/reusable_sections/Footer";
import LixrExperienceBegins from "./sections/LixrExperienceBegins";
export default function RequestAQuotePage() {
  return <div>
      <Header />
      <LixrExperienceBegins />
      <LeadIntakeFormSection />
      <CommentCaFonctionne />
      <MarketplaceFooter />
    </div>;
}